module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/wiktoria-tulodziecka-4cd7cc0fb7bf9127bb8eb2abc81f4749.webp";